const CARDS = [
  {
    img: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=800&q=80",
    alt: "Isolated VPC ingress architecture",
    index: "01 \u2022 Ingress Isolation",
    title: "Private VPC Boundaries",
    body: "No token leaves your designated infrastructure. Multi-region routing happens entirely within defined VPC peering limits.",
    testid: "fabric-card-vpc",
  },
  {
    img: "https://images.unsplash.com/photo-1617839625591-e5a789593135?auto=format&fit=crop&w=800&q=80",
    alt: "Cryptographic token guard verification",
    index: "02 \u2022 Context Guardrails",
    title: "Automated PII Neutralization",
    body: "Inspect and sanitize prompt payloads at wire speed prior to model execution with full compliance auditing.",
    testid: "fabric-card-pii",
  },
  {
    img: "https://images.unsplash.com/photo-1709377195538-5522ed0f9e10?auto=format&fit=crop&w=800&q=80",
    alt: "Model failover circuit topology",
    index: "03 \u2022 Resilient Weave",
    title: "Dynamic MCP Fallbacks",
    body: "Seamless routing between Claude, OpenAI, and internal open-source models with automated cost budgeting.",
    testid: "fabric-card-fallback",
  },
];

export default function Fabric() {
  return (
    <section
      id="fabric"
      className="py-24 px-6 border-b border-linen"
      data-testid="fabric-section"
    >
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl mb-16">
          <span className="font-mono text-xs uppercase tracking-widest text-clay font-bold">
            System Mechanics
          </span>
          <h2 className="font-display text-3xl md:text-4xl text-ink mt-2">
            Engineered for security leaders and platform architects
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {CARDS.map((card) => (
            <div key={card.title} className="border-t border-ink pt-6" data-testid={card.testid}>
              <div className="relative aspect-video mb-6 border border-linen overflow-hidden bg-espresso">
                <img
                  src={card.img}
                  alt={card.alt}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover sl-drift sl-grade"
                />
              </div>
              <span className="font-mono text-xs text-clay block mb-1">{card.index}</span>
              <h3 className="font-display text-xl text-ink font-bold mb-2">{card.title}</h3>
              <p className="font-body text-sm text-umber leading-relaxed">{card.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
